import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {PopupSize} from '@web/core/constants'
import {ROUTER_ORDER_PURCHASE_CONFIRMATION} from '@web/core/routes'
import {changeBrowserLocation, openNewTab, openPopup} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {LocationChangeHistoryParam, NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

type NavigatePurchaseConfirmParams = NavigationTypeSelectableParam &
    LocationChangeHistoryParam & {
        orderNo: string
        productOrderNo: string
        backUrl?: string
    }

const POPUP_KEY = 'DELIVERY_TRACKING_PURCHASE_CONFIRM'

/**
 * 구매확정 페이지 열기.
 * - 모바일은 새탭, pcs는 팝업으로 오픈.
 * - forceLocationChange가 true면 모바일/pc 구분없이 historyType(default: PUSH) 으로 이동.
 */
const navigateToPurchaseConfirm = createAsyncThunk<NavigationResult, NavigatePurchaseConfirmParams, ThunkApi>(
    'navigateTo/purchaseConfirm',
    async (params) => {
        const {forceLocationChange = false, historyType = 'PUSH', orderNo, productOrderNo, backUrl} = params

        const url = qs.stringifyUrl({
            url: ROUTER_ORDER_PURCHASE_CONFIRMATION.MAIN.getHref(`/${orderNo}`),
            query: {
                clickedId: productOrderNo,
                ...(backUrl && {backUrl}),
            },
        })

        if (forceLocationChange) {
            changeBrowserLocation({type: historyType, url})
        } else if (isMobile) {
            openNewTab({url})
        } else {
            openPopup({
                key: POPUP_KEY,
                url,
                title: '구매확정',
                size: {
                    width: PopupSize.common.width,
                    height: PopupSize.common.height,
                },
            })
        }

        return Promise.resolve()
    },
)

export default navigateToPurchaseConfirm
